export const environment = {
  production: false,
  
  // Used by nexchat-enterprise components
  apiUrl: 'https://api-qa.brainbotsdigital.com', 
  
  // Used by imported nexchat-core components (points to new enterprise backend)
  apiURL: 'https://api-qa.brainbotsdigital.com', 
  
  // Frontend URL for this enterprise app
  feURL: 'https://qa.brainbotsdigital.com', 
  
  // Facebook Pixel tracking config required by core services
  fbPixel: {
    enabled: false,
    id: ''
  }
};
